import React from 'react'
import PropTypes from 'prop-types'

import { normalizeBookingPayload } from '../helpers/bookingHelper'

const initialState = {
  isLoading: false,
  user: null,
  booking: null,
  filtered: null,
  all: null,
  cancellation: null,
  meta: null,
}

export const BOOKING = {
  LOADING: 'BOOKING/LOADING',
  SET: 'BOOKING/SET',
  UPDATE: 'BOOKING/UPDATE',
  ALL: 'BOOKING/ALL',
  META: 'BOOKING/META',
  CANCELLATION: {
    SET: 'BOOKING/CANCELLATION/SET'
  },
  USER: {
    SET: 'BOOKING/USER/SET'
  }
}

let reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState
    case BOOKING.LOADING:
      return { ...state, isLoading: action.payload }
    case BOOKING.SET:
      return { ...state, booking: action.payload }
    case BOOKING.ALL:
      return { ...state, all: normalizeBookingPayload(action.payload) }
    case BOOKING.META:
      return { ...state, meta: action.payload }
    case BOOKING.CANCELLATION.SET:
      return { ...state, cancellation: action.payload }
    case BOOKING.UPDATE:
      let filtered = null
      if (state.filtered) {
        filtered = state.filtered.map(booking => {
          if (booking.id === action.payload.id) {
            return action.payload
          }
          return booking
        })
      }
      let bookings = state.all.map(booking => {
        if (booking.id === action.payload.id) {
          return action.payload
        }
        return booking
      })
      return { ...state, all: bookings, filtered: filtered }
    case BOOKING.USER.SET:
      return { ...state, user: action.payload }
    default:
      return state
  }
}

export const BookingContext = React.createContext()

export const BookingProvider = ({ children }) => {
  let [state, dispatch] = React.useReducer(reducer, initialState)
  let value = { state, dispatch }

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  )
}

BookingProvider.propTypes = {
  children: PropTypes.node
}

export const BookingConsumer = BookingContext.Consumer
